export const en = {
  // Navigation
  nav: {
    home: "Home",
    explore: "Explore",
    myEvents: "My Events",
    profile: "Profile",
  },

  // Auth
  auth: {
    signIn: "Sign In",
    signUp: "Create Account",
    signingIn: "Signing in...",
    creatingAccount: "Creating account...",
    email: "Email",
    emailPlaceholder: "you@email.com",
    password: "Password",
    passwordPlaceholder: "Your password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Repeat your password",
    createSecurePassword: "Create a secure password",
    firstName: "First Name",
    firstNamePlaceholder: "Your first name",
    lastName: "Last Name",
    lastNamePlaceholder: "Your last name",
    birthDate: "Date of Birth",
    selectDate: "Select date",
    gender: "Gender",
    selectGender: "Select your gender",
    male: "Male",
    female: "Female",
    preferNotToSay: "Prefer not to say",
    phoneNumber: "Phone number",
    phonePlaceholder: "123 456 7890",
    phoneTaken: "Phone already registered",
    phoneTakenDesc: "This phone number is already associated with another account.",
    phoneInvalid: "Invalid phone",
    phoneInvalidDesc: "Phone number must be exactly 10 digits.",
    noAccount: "Don't have an account?",
    createHere: "Create one here",
    haveAccount: "Already have an account?",
    signInHere: "Sign in here",
    or: "or",
    iAmJudge: "I'm a Court Judge",
    welcome: "Welcome!",
    accountCreated: "Your account has been created.",
    signedIn: "You have signed in successfully.",
    signUpError: "Sign up error",
    signInError: "Sign in error",
    unexpectedError: "An unexpected error occurred",
    weakPassword: "Weak password",
    weakPasswordDesc: "Password must have at least 8 characters, a number, and a special character.",
    passwordsMismatch: "Passwords don't match",
    passwordsMismatchDesc: "Please verify that both passwords are the same.",
    login: "Log in",
    ok: "OK",
  },

  // Common
  common: {
    loading: "Loading...",
    error: "Error",
    save: "Save",
    cancel: "Cancel",
    back: "Back",
    search: "Search",
    all: "All",
    close: "Close",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    yes: "Yes",
    no: "No",
    free: "Free",
    register: "Register",
    registered: "Registered",
    share: "Share",
    details: "Details",
    viewMore: "View more",
    viewAll: "View all",
    noResults: "No results",
    retry: "Retry",
    sport: "Sport",
    location: "Location",
    date: "Date",
    time: "Time",
    category: "Category",
    participants: "Participants",
    user: "User",
  },

  // Dashboard / Home
  dashboard: {
    greeting: "Hello",
    loadingExperience: "Preparing your experience...",
    featuredEvents: "Featured Events",
    featuredOrganizers: "Featured Organizers",
    suggestedClubs: "Suggested Clubs",
    myUpcomingEvents: "My Upcoming Events",
    tournaments: "Tournaments",
    leagues: "Leagues",
    noUpcomingEvents: "You have no upcoming events",
    exploreEvents: "Explore available events!",
    viewAllMyEvents: "View all my events",
  },

  // Explore
  explore: {
    tournaments: "Tournaments",
    leagues: "Leagues",
    organizers: "Organizers",
    players: "Players",
    clubs: "Clubs",
    searchPlaceholder: "Search tournaments by name, sport or location...",
    searchPlayers: "Search by name, email or location...",
    searchOrganizers: "Search organizers...",
    searchLeagues: "Search leagues by name, sport or location...",
    searchPlayersTitle: "Search players",
    searchPlayersHint: "Type at least 2 characters to search by name or location",
    noEventsFound: "No events found",
    noPlayersFound: "No players found",
    noOrganizersFound: "No organizers found",
    noLeaguesFound: "No leagues found",
    adjustSearch: "Try adjusting your search",
    adjustSearchFilters: "Try adjusting your search or filters",
    loadingPlayers: "Loading players...",
    loadingLeagues: "Loading leagues...",
    errorLoadingPlayers: "Error loading players",
    viewProfile: "View profile",
    eventsHeld: "events held",
    upcomingEvents: "upcoming events",
    all: "All",
    filterByDistance: "Filter by distance",
    distance: "Distance",
    noLimit: "No limit",
    close: "Nearby",
    medium: "Medium",
    far: "Far",
    filters: "Filters",
  },

  // Players
  players: {
    follow: "Follow",
    following: "Following",
    friends: "Friends",
    followBack: "Follow back",
    sending: "Sending...",
    nowFollowing: "Now following",
    followError: "Error following user",
  },

  // My Events
  myEventsPage: {
    upcoming: "Upcoming",
    active: "Active",
    finished: "Finished",
    noEvents: "You have no events",
    noUpcoming: "You have no upcoming events",
    noActive: "You have no active events",
    noFinished: "You have no finished events",
  },

  // Profile
  profile: {
    myProfile: "My Profile",
    settings: "Settings",
    editProfile: "Edit profile",
    tournaments: "Tournaments",
    followers: "Followers",
    following: "Following",
    recentActivity: "Recent Activity",
    friends: "Friends",
    myEvents: "My Events",
    achievements: "Achievements",
    idCopied: "ID copied to clipboard",
    idCopyError: "Could not copy ID",
    favoriteSports: "Favorite Sports",
    noActivity: "No recent activity",
    aboutMe: "About me",
    tournamentStats: "Tournament Statistics",
    tournamentHistory: "Tournament History",
    participation: "Participation",
    noTournamentHistory: "No tournament history yet",
    subcategoryLabel: "Subcategory",
    quarterFinals: "Quarter Finals",
    semiFinals: "Semi Finals",
    runnerUp: "Runner-up",
    champion: "Champion",
    pts: "Pts",
    format: "Format",
    circuit: "Circuit",
    blitz: "Blitz",
    totalPoints: "Total Pts",
    signInToSeeProfile: "Sign in to see your profile",
    loadingProfile: "Loading profile...",
    eventHistory: "Event History",
    noEvents: "You have no events",
    noEventsRegistered: "No events registered",
    registerFirst: "Register for your first tournament or league!",
    noEventsOther: "This user has not participated in events yet",
    exploreEvents: "Explore Events",
    viewAllEvents: "View All Events",
    eventsLabel: "events",
    viewLess: "View less",
    review: "Review",
    reviewed: "Reviewed",
    reviewOrganizer: "Review organizer",
    optionalComment: "Optional comment...",
    submit: "Submit",
    submitting: "Submitting...",
    add: "Add",
    searchFriends: "Search Friends",
    searchByName: "Search by name...",
    friend: "Friend",
    pending: "Pending",
    noFriendsYet: "You have no friends yet",
    searchAndFollow: "Search and follow some users!",
    chatStarted: "Chat started",
    level: "Level",
    challenge: "Challenge",
    networkStats: "Network Stats",
    requests: "Requests",
    athletes: "Athletes",
    loadingFriends: "Loading friends...",
    followError: "Error following user",
    nowFollowing: "Now following this user",
    statusActive: "Active",
    statusUpcoming: "Upcoming",
    statusFinished: "Finished",
    total: "total",
    back: "Back",
    loading: "Loading...",
    profileNotFound: "Profile not found",
    userNotAvailable: "This user does not exist or is not available.",
    backToHome: "Back to home",
    memberSince: "Member since",
    noLocation: "No location",
    mutualFriends: "Friends",
    follow: "Follow",
    followBackLabel: "Follow back",
    message: "Message",
    aboutUser: "About",
    thisUser: "this user",
    statistics: "Statistics",
    ranking: "Ranking",
    myCircuits: "My Circuits",
    position: "Position",
    noRankings: "You don't have a ranking in any circuit yet",
    noRankingsDesc: "Register for a tournament to start earning points",
    tournamentsPlayed: "Tournaments played",
    viewCircuit: "View circuit",
  },

  // Settings
  settings: {
    title: "Settings",
    personal: "Personal",
    notifications: "Alerts",
    privacy: "Privacy",
    account: "Account",
    support: "Support",
    language: "Language",
    fullName: "Full name",
    bio: "Bio",
    locationLabel: "Location",
    phone: "Phone",
    skillLevel: "Skill level",
    preferredSports: "Preferred sports",
    saveChanges: "Save Changes",
    saving: "Saving...",
    savedSuccess: "Profile updated successfully",
    savedError: "Error updating profile",
    emailNotifications: "Email notifications",
    eventReminders: "Event reminders",
    friendRequests: "Friend requests",
    profileVisibility: "Profile visibility",
    public: "Public",
    friendsOnly: "Friends only",
    private: "Private",
    showActivity: "Show activity",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    passwordChanged: "Password updated successfully",
    passwordChangeError: "Error changing password",
    signOut: "Sign out",
    downloadData: "Download my data",
    downloading: "Downloading...",
    deleteAccount: "Delete my account",
    deleteAccountWarning: "This action is irreversible",
    helpCenter: "Help center",
    termsOfService: "Terms of service",
    privacyPolicy: "Privacy policy",
    contactUs: "Contact us",
    version: "Version",
  },

  // Events
  events: {
    tournament: "Tournament",
    league: "League",
    registrationFee: "Registration Fee",
    registrationDeadline: "Registration Deadline",
    maxParticipants: "Spots",
    format: "Format",
    matchType: "Match Type",
    singles: "Singles",
    doubles: "Doubles",
    both: "Both",
    roundRobin: "Round Robin",
    elimination: "Single Elimination",
    sumGames: "Sum of Games",
    ladder: "Ladder/Pyramid",
    rules: "Rules",
    prizes: "Prizes",
    schedule: "Schedule",
    standings: "Standings",
    bracket: "Bracket",
    groups: "Groups",
    myGroup: "My Group",
    allGroups: "All Groups",
    matches: "Matches",
    results: "Results",
    info: "Info",
    startDate: "Start",
    endDate: "End",
    organizedBy: "Organized by",
    available: "available",
    spotsLeft: "spots left",
    eventFull: "Event full",
    registrationClosed: "Registration closed",
    alreadyRegistered: "Already registered",
    guaranteedMatches: "Guaranteed matches",
    setsPerMatch: "Sets per match",
    goldenPoint: "Golden point",
    superTieBreak: "Super tie-break",
    gamesPerSet: "Games per set",
    upcoming: "Upcoming",
    perPerson: "per person",
    perPair: "per pair",
    perPersonPair: "per person/pair",
    byOrganizer: "by",
    deadline: "Deadline",
    closed: "Closed",
    lastDay: "Last day!",
    dayLeft: "day",
    daysLeft: "days",
    viewPrizes: "View Prizes",
    noFeaturedEvents: "No featured events for",
    exploreAllEvents: "Explore all events to find options for",
    viewAllEvents: "View all events",
    popularUpcoming: "Popular upcoming tournaments and leagues",
    encounters: "matches",
    nextEncounter: "Next match",
    encounter: "Encounter",
    opponent: "Opponent",
    court: "Court",
    groupsPending: "Groups pending assignment",
    matchesPending: "Matches pending scheduling",
    tapForDetails: "Tap to view details",
    yourNextEvent: "Your next event",
    yourNextEvents: "Your next events",
    loadingEvents: "Loading events...",
    noTournamentsFound: "No tournaments found",
    adjustSearch: "Try adjusting your search or filters",
    filterByDistance: "Filter by distance",
    singlesAndDoubles: "Singles and Doubles",
  },

  // Judge
  judge: {
    title: "Judge Access",
    enterCode: "Enter your access code",
    codePlaceholder: "6-digit code",
    codeError: "Code must be 6 characters",
    validate: "Validate",
    validating: "Validating...",
    pending: "Pending",
    completed: "Completed",
    court: "Court",
    match: "Match",
    vs: "vs",
    assignScore: "Assign Score",
    noMatches: "No matches",
    noPendingMatches: "No pending matches",
    noCompletedMatches: "No completed matches",
    day: "Day",
    allDays: "All",
    phase: "Phase",
    group: "Group",
    refreshMatches: "Refresh matches",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    backToLogin: "Back to home",
    tournamentOf: "Tournament of",
    welcomeJudge: "Welcome, Judge",
  },

  // Notifications
  notifications: {
    title: "Notifications",
    chats: "Chats",
    noNotifications: "You have no notifications",
    markAllRead: "Mark all as read",
    newMessage: "New message",
    subtitle: "Stay up to date with the latest updates",
    chatsSubtitle: "Your active conversations",
    noNotificationsTitle: "No notifications",
    noNotificationsDesc: "We'll notify you when there are important updates",
    deleted: "Notification deleted",
    allDeleted: "All notifications deleted",
    chatDeleted: "Conversation deleted",
    chatDeleteError: "Error deleting conversation",
    chatStartError: "Error starting conversation",
    followedBack: "You are now following this user",
    followBackError: "Error following back",
    processError: "Could not process notification",
    viewProfile: "View profile",
    followBack: "Follow back",
    reject: "Reject",
    register: "Register",
    newConversation: "New conversation",
    tabAll: "All",
    tabFriends: "Friends",
    tabOrganizers: "Organizers",
    noChatsAll: "No conversations",
    noChatsAllDesc: "Your chats with other players and clubs will appear here",
    noChatsFriends: "No conversations with friends",
    noChatsFriendsDesc: "Your chats with friends will appear here",
    noChatsOrganizers: "No conversations with organizers",
    noChatsOrganizersDesc: "Your chats with event organizers will appear here",
    noMessages: "No messages",
    timeNow: "Now",
    timeMinAgo: "{n} min ago",
    timeHoursAgo: "{n}h ago",
    timeDaysAgo: "{n}d ago",
    searchContact: "Search contact...",
    noContactsAvailable: "You have no contacts available.",
    noContactsHint: "Follow other players or register for events to chat with organizers.",
    noContactsFound: "No contacts found for",
  },

  // Registration
  registration: {
    title: "Registration",
    step: "Step",
    of: "of",
    personalData: "Personal data",
    payment: "Payment",
    confirmation: "Confirmation",
    selectCategory: "Select category",
    selectSubcategory: "Select subcategory",
    partner: "Partner",
    selectPartner: "Select partner",
    invitePartner: "Invite partner",
    noPartner: "No partner (one will be assigned)",
    payNow: "Pay now",
    payLater: "Pay later",
    registrationComplete: "Registration complete!",
    registrationError: "Registration error",
    accessCode: "Access code",
    accessCodeEntry: {
      title: "Enter Access Code",
      description: "Enter the 6-character code provided by the organizer",
      verifyButton: "Verify Code",
      verifying: "Verifying...",
      footerNote: "The code was generated when the organizer registered you manually",
      registrationFound: "Registration found!",
      event: "Event",
      category: "Category",
      players: "Players",
      you: "You",
      claimButton: "Claim my registration",
      claiming: "Claiming registration...",
      useAnotherCode: "Use another code",
    },
    progressSteps: {
      participant: "Participant",
      participantDesc: "Modality and participants",
      payment: "Payment",
      paymentDesc: "Payment information",
      confirmation: "Confirmation",
      confirmationDesc: "Final summary",
    },
    page: {
      loading: "Loading event...",
      notFound: "Event not found",
      backToHome: "Back to home",
      back: "Back",
      registrationTo: "Registration for",
      league: "League",
      tournament: "Tournament",
    },
    dataStep: {
      title: "Registration Data",
      descriptionLeague: "Complete the information to register for the league",
      descriptionTournament: "Complete the information to register for the tournament",
      modality: "Modality",
      singlesLabel: "Singles (Individual)",
      singlesOnlyLeague: "This league is singles only",
      singlesOnlyTournament: "This tournament is singles only",
      doublesLabel: "Doubles (Pairs)",
      doublesOnlyLeague: "This league is doubles only, you'll need a partner",
      doublesOnlyTournament: "This tournament is doubles only, you'll need a partner",
      category: "Category",
      categoryOfLeague: "Category for this league",
      categoryOfTournament: "Category for this tournament",
      selectCategory: "Select a category",
      subcategory: "Subcategory",
      subcategoryOfLeague: "Subcategory for this league",
      subcategoryOfTournament: "Subcategory for this tournament",
      selectSubcategory: "Select a subcategory",
      full: "FULL",
      available: "available",
      enrolled: "enrolled",
      enrolledPlural: "enrolled",
      loadingAvailability: "Loading availability...",
      spotsAvailable: "Spots available in",
      pair: "pair",
      pairs: "pairs",
      lastSpots: "Last spots",
      spotsFull: "Spots full in",
      playerNames: "Player Names",
      playerName: "Player Name",
      player1: "Player 1",
      fullName: "Full name",
      enterFullName: "Enter your full name",
      howAddPartner: "How would you like to add your partner?",
      manualEntry: "Enter name manually",
      selectFromFriends: "Select from my friends",
      partnerName: "Partner's name",
      enterPartnerName: "Enter your partner's name",
      payBothNote: "You will be responsible for paying the full registration for both",
      searchFriend: "Search friend",
      fullPayment: "Full payment",
      fullPaymentNote: "You will pay the full registration for you and",
      fullPaymentDesc: "You pay the full registration for you and",
      partnerDefault: "your partner",
      invitationNote: "An invitation will be sent for them to confirm their participation.",
      paymentModeLabel: "How would you like to pay?",
      splitPaymentLabel: "Split payment",
      each: "each",
      splitPaymentDesc: "You pay your half now.",
      splitPaymentHours: "will have {hours} hours to pay their part.",
      splitNotAvailable: "Not available — the event is too close to use split payment.",
      back: "Back",
      spotsExhausted: "Spots Exhausted in this Subcategory",
      continue: "Continue",
      promo: {
        title: "Promotional coupon",
        placeholder: "Enter your code",
        apply: "Apply",
        applying: "Validating...",
        valid: "Discount",
        invalid: "Invalid code or not available for this event",
        expired: "This code has reached its usage limit",
        savings: "Savings",
        remove: "Remove",
      },
    },
  },

  // Payment
  payment: {
    title: "Payment",
    processing: "Processing payment...",
    success: "Payment successful!",
    error: "Payment error",
    amount: "Amount",
    method: "Payment method",
    card: "Card",
    transfer: "Transfer",
    paymentInfo: "Payment Information",
    completePayment: "Complete the payment to finalize your registration",
    registrationSummary: "Registration Summary",
    event: "Event",
    modality: "Modality",
    singles: "Singles",
    doubles: "Doubles",
    category: "Category",
    subcategory: "Subcategory",
    player1: "Player 1",
    partner: "Partner",
    paymentType: "Payment type",
    fullPayment: "Full payment",
    totalToPay: "Total to pay",
    doublesNote: "Includes full registration for both players. An invitation will be sent to your partner.",
    paymentMethod: "Payment Method",
    backToData: "Back to Data",
    paymentProcess: "Payment Process",
    completeRegistration: "Complete your registration",
    back: "Back",
    paymentSummary: "Payment Summary",
    participants: "Participants",
    currentUser: "Current User",
    pair: "Partner",
    eventInfo: "Event Information",
    location: "Location",
    date: "Date",
    time: "Time",
    sport: "Sport",
    individual: "Individual",
    pairs: "Pairs",
    format: "Format",
    league: "League",
    tournament: "Tournament",
    organizer: "Organizer",
    deadline: "Deadline",
    prizes: "Prizes",
    prizesAvailable: "prizes available",
    paymentMode: "Payment Mode",
    splitPayment: "Split payment",
    partnerPayNotice: "A notification will be sent to your partner to complete the payment",
    partnerPayHalf: "Your partner will pay the other half separately",
    secureStripe: "Secure payment with Stripe",
    redirectNotice: "You will be redirected to a secure payment page to complete your transaction",
    sslNotice: "Your payment information is protected with bank-level SSL encryption",
    creatingSession: "Creating payment session...",
    proceedPayment: "Proceed to Payment",
    openingWindow: "A new window will open with Stripe's secure payment page",
    termsNotice: "By confirming the payment, you accept the event's terms and conditions and cancellation policy.",
    openingPaymentPage: "Opening payment page...",
    openingStripePage: "Opening Stripe payment page...",
    errorCreatingSession: "Error creating payment session",
    noPaymentUrl: "Payment URL not received",
    errorProcessing: "Error processing payment",
    sumatoriaJuegos: "Game Sum",
    escaleraFormat: "Ladder (Pyramid Format)",
    directElimination: "Direct Elimination",
    roundRobin: "Round Robin",
    installments: "Monthly Installments (MSI)",
    payInFull: "Pay in full",
    months3: "3 months interest-free",
    months6: "6 months interest-free",
    months9: "9 months interest-free",
    months12: "12 months interest-free",
    msiNote: "Only available for Mexican credit cards. Stripe will show available options based on your card.",
    msiAvailable: "Monthly installments available",
    selectPlan: "Select a payment plan",
    yourPart: "Your part",
    splitPaymentNote: "Your payment will be held until {name} completes their part. If they don't pay in time, your charge will be released.",
    splitInfoBanner: "Your payment will be temporarily held. When {name} pays their half, both payments will be processed and the registration will be confirmed.",
  },

  // Dates
  dates: {
    today: "Today!",
    tomorrow: "Tomorrow",
    yesterday: "Yesterday",
    days: "days",
    day: "day",
    hours: "hours",
    hour: "hour",
    minutes: "minutes",
    min: "min",
    ago: "ago",
    in: "in",
    thisWeek: "This week",
  },

  // Sports
  sports: {
    padel: "Padel",
    tennis: "Tennis",
    pickleball: "Pickleball",
  },

  // Skill levels
  levels: {
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    professional: "Professional",
  },
  categories: {
    masculino: "Men's",
    femenino: "Women's",
    mixto: "Mixed",
  },
  subcategories: {
    "1era": "Division 1",
    "2nda": "Division 2",
    "3era": "Division 3",
    "4ta": "Division 4",
    "5ta": "Division 5",
    "6ta": "Division 6",
  },
  prizes: {
    title: "Prizes",
    titleWithEvent: "Prizes - {event}",
    firstPlace: "First Place",
    secondPlace: "Second Place",
    noPrizes: "No prize information available for this event.",
    trophy: "Trophy",
    paddle: "Paddle",
    racket: "Racket",
    certificate: "Certificate",
    otherPrize: "Other prize",
    prize: "Prize",
  },

  // Event Detail / Registration Form
  eventDetail: {
    organizer: "Organizer",
    registrationDeadline: "Registration deadline",
    guaranteedMatches: "Guaranteed matches",
    categories: "Categories",
    modality: "Modality",
    price: "Price",
    perPerson: "per person",
    perPair: "per pair",
    perParticipation: "per participation",
    perPersonPair: "per person/pair",
    viewPrizes: "View Prizes",
    format: "Format",
    encounters: "Matches",
    matches: "matches",
    registrationsClosed: "Registration closed",
    daysLeft: "days left",
    dayLeft: "day left",
    signMeUp: "Sign me up!",
    tournamentFull: "Tournament Full",
    leagueFull: "League Full",
    accessCode: "Have an access code?",
    contactOrganizer: "Contact organizer",
    gameCalendar: "Game Schedule Calendar",
    weeks: "weeks",
    swipeMore: "Swipe to see more weeks →",
    eliminationPhase: "Elimination Phase",
    eliminationDesc: "Top qualifiers from the regular phase will advance to the playoffs to determine the champion.",
    bookEncounter: "Book your match (Mon-Sun)",
    noCategories: "No categories configured",
    pairs: "pairs",
    registered: "registered",
    linkCopied: "Link copied to clipboard",
    organizerNotFound: "Organizer not found",
    chatError: "Could not start chat",
  },

  // League Details
  league: {
    organizer: "Organizer",
    prizes: "Prizes",
    rules: "Rules",
    gameRules: "Game Rules",
    format: "Format",
    category: "Category",
    subcategory: "Subcategory",
    partner: "Partner",
    roundRobin: "Round Robin",
    sumatoria: "Sum of Games",
    sumatoriaDeJuegos: "Sum of Games",
    escalera: "Ladder",
    escaleraLabel: "Pyramid Ladder",
    leagueCalendar: "League Calendar",
    encounter: "Match",
    week: "Week",
    rest: "Rest",
    willYouAttend: "Will you attend?",
    confirmAttendance: "Confirm attendance?",
    willAttend: "I'll attend",
    wontAttend: "Won't attend",
    regularPhase: "Regular Phase",
    regular: "Regular",
    elimination: "Elimination",
    eliminationPhase: "Elimination Phase",
    totalEncounters: "Total Matches",
    encountersLabel: "Matches",
    past: "Past",
    current: "Current",
    future: "Upcoming",
    eliminationPhases: "Elimination Phases",
    eliminationStructure: "Elimination Structure",
    eliminationSchedule: "Elimination Schedule",
    autoClassification: "Automatic Qualification",
    classifyTop: "Top {count} from the regular phase qualify automatically",
    octavos: "Round of 16",
    cuartos: "Quarterfinals",
    semifinales: "Semifinals",
    final: "Final",
    standings: "Standings",
    podium: "Podium",
    you: "YOU",
    wins: "Wins",
    losses: "Losses",
    setsFor: "Sets W",
    setsAgainst: "Sets L",
    gamesFor: "Games W",
    gamesAgainst: "Games L",
    difference: "Diff",
    points: "Pts",
    pos: "Pos",
    pair: "Pair",
    player: "Player",
    systemRoundRobin: "System: 3 points per win, 0 per loss",
    tiebreakRoundRobin: "Tiebreak: 1) Matches won 2) Set difference 3) Game difference",
    systemSumatoria: "System: Total games accumulated",
    tiebreakSumatoria: "Tiebreak: 1) Games won 2) Difference",
    toBeConfirmed: "TBD",
    next: "Next",
    completed: "Completed",
    // Game rules labels
    gameFormat: "Game Format",
    setTiebreak: "Set Tiebreak",
    goldenPoint: "Golden Point",
    thirdSet: "Third Set",
    matchesPerDay: "Matches per Day",
    objective: "Objective",
    tiebreak: "Tiebreak",
    bestOf3Sets: "Best of 3 sets",
    tiebreakAt66: "Tiebreak at 7 points on 6-6",
    yesAt4040: "Yes at 40-40",
    superTiebreak10: "Super Tiebreak to 10 points",
    twentyMinMatches: "20-minute matches",
    threeMatchesPerDay: "3 matches per league day",
    sumMostGames: "Accumulate the most games",
    tiebreakDifference: "Greatest difference Games Won - Games Lost",
    // Escalera specific
    challengeFormat: "Challenge Format",
    challengeResult: "Result",
    challengeEncounters: "Matches",
    challengePlayoff: "Playoff",
    challengeSimple: "Challenge 1 position above",
    challengeDouble: "Challenge 1 or 2 positions above",
    pairChallenge: "Court pairs challenge each other",
    winnerGoesUp: "Winner moves up, loser moves down",
    winnerTakesPosition: "Winner takes the higher position",
    alwaysEncounters: "Matches are always played between pairs",
    top4Classify: "Top 4 qualify for final playoffs",
    topCourtLabel: "Top Court",
    middleCourtLabel: "Intermediate Court",
    rotatingPartners: "Rotating Partners",
    resultWeek: "Result Week",
    yourChallenge: "Your Challenge - Week",
    // Sumatoria specific
    weekSummary: "Week Summary",
    gamesAdded: "Games Won",
    gamesAgainstLabel: "Games Lost",
    swipeMoreMatches: "Swipe to see more matches",
    matchLabel: "Match",
    courtLabel: "Court",
    toPlay: "To play",
    seasonInProgress: "Season in progress",
    aboutToStart: "About to start",
    // Court booking
    bookCourt: "Book Court",
    oneBookingPerWeek: "1 booking per week",
    loadingAvailability: "Loading availability...",
    restWeekLabel: "Rest week",
    noMatchesThisWeek: "No matches scheduled this week",
    noSlotsAvailable: "No slots available for this week",
    yourBooking: "Your booking",
    cancel: "Cancel",
    allSlotsBooked: "All slots are booked",
    availableSlots: "Available slots:",
    booked: "Booked",
    available: "Available",
    register: "Register",
    book: "Book",
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
    },
    dayAbbr: {
      mon: "M",
      tue: "T",
      wed: "W",
      thu: "T",
      fri: "F",
      sat: "S",
      sun: "S",
    },
    // Encounter selector & status badges
    selectEncounter: "Select match",
    encounterLabel: "Match",
    restWeekNum: "Rest (Week {n})",
    roundOf16: "Round of 16",
    quarterFinals: "Quarterfinals",
    semiFinals: "Semifinals",
    restWeekTitle: "Rest week",
    noMatchThisWeek: "No match scheduled this week.",
    loading: "Loading",
    completedStatus: "Completed",
    scheduledStatus: "Scheduled",
    toSchedule: "To be scheduled",
    inProgress: "In progress",
    waitingStatus: "Waiting",
    oddsVsEvens: "Odds vs Evens",
    evensVsOdds: "Evens vs Odds",
    positionRange: "Range of {n} positions",
    positionRangeGeneric: "Position range",
    loadingElimination: "Loading elimination matches...",
    notAssigned: "Not yet assigned",
    loadingChallenges: "Loading challenges...",
    noChallenge: "No challenge assigned",
    noChallengeDesc: "You don't have a challenge assigned for this week.",
    waitingResults: "Waiting for Match {n} results",
    waitingResultsDesc: "Matchups will be determined once the previous match is completed.",
    encounterToSchedule: "Match to be scheduled",
    encounterToScheduleDesc: "This match doesn't have games assigned yet.",
    noMatchesAssigned: "No matches assigned",
    noMatchesAssignedDesc: "You don't have matches scheduled for this encounter.",
    loadingMatches: "Loading matches...",
    yourMatch: "Your match",
    matchResult: "Match Result",
    yourChallengeTitle: "Your Challenge",
    matchOfTheWeek: "Match of the Week",
    upcomingMatch: "Upcoming scheduled match",
    won: "You won",
    lost: "You lost",
    pendingResult: "Pending",
    yourChallengeWeek: "Your Challenge - Week {n}",
    challenger: "Challenger",
    challenged: "Challenged",
    youLabel: "YOU",
    attendanceConfirmed: "Your attendance confirmed",
    attendanceDeclined: "You indicated you won't attend",
    confirmYourAttendance: "Confirm your attendance",
    opponentConfirmed: "Opponent attendance confirmed",
    opponentDeclined: "Opponent won't attend",
    opponentPending: "Opponent attendance pending",
    currentLabel: "Current",
    // Ranking section
    leagueRanking: "League Ranking",
    viewRanking: "View ranking",
    initialRanking: "Initial Ranking",
    movement: "Movement",
    noRankingData: "No ranking data available",
    maintains: "Holds",
    pendingMovement: "Pending",
  },

  // Format Info Dialog
  formatInfo: {
    features: "Features:",
    matchConfig: "Match Configuration",
    setsPerMatch: "Sets per match:",
    gamesPerSet: "Games per set:",
    goldenPointOn: "Golden Point enabled",
    goldenPointOff: "Golden Point: No",
    superTiebreakOn: "Super Tiebreak enabled",
    superTiebreakOff: "Super Tiebreak: No",
    gameTiming: "Game Timing",
    warmup: "Warmup:",
    restBetweenSets: "Rest between sets:",
    sideChange: "Side change:",
    minutes: "minutes",
    seconds: "seconds",
    scheduleAndDays: "Schedule & Days",
    gameDays: "Game days:",
    schedule: "Schedule:",
    to: "to",
    conduct: "Rules",
    arrivalTolerance: "Arrival tolerance:",
    roundRobin: {
      title: "Round Robin Format (Everyone vs Everyone)",
      description: "In this format, each participant plays against all other participants in the group. The winner is determined by the most victories or accumulated points.",
      features: ["All teams play each other at least once", "Guarantees a minimum number of matches for everyone", "Rankings determined by total wins", "Ideal for assessing each participant's true level"],
      advantage: "This format ensures all participants have multiple opportunities to play and compete.",
    },
    sumatoria: {
      title: "Sum of Games Format",
      description: "Similar to Round Robin, but rankings are determined by the total sum of games won across all matches, not just victories.",
      features: ["Everyone plays everyone", "ALL games won are counted", "Example: winning 6-4, 6-3 adds 12 games", "Rewards consistent performance"],
      advantage: "This system values every game won, making every point count toward the final result.",
    },
    escalera: {
      title: "Ladder Format (Pyramid)",
      description: "Players are organized in hierarchical levels. You can challenge players above you. If you win, you swap positions. The goal is to reach the top of the ladder.",
      features: ["Organization by levels or positions", "You can challenge higher-ranked players (usually up to 2 positions above)", "If you win the challenge, positions are swapped", "Flexible scheduling - players coordinate their own matches"],
      advantage: "Ideal format for long leagues with scheduling flexibility, where players can arrange their own matches.",
      specialFeatures: "Special Ladder Features",
      scheduledOn: "Matches scheduled on:",
      dateFlexibility: "Date flexibility:",
      dateFlexibilityDesc: "Players can schedule matches on any mutually agreed day",
      directCoordination: "Direct coordination",
      directCoordinationDesc: "between players to schedule matches",
    },
    doublesEscalera: {
      title: "Ladder Format - King of the Court",
      description: "In this format, pairs compete in matches organized by court. The court number represents your ranking position. Pairs on each court face off, and the winner moves up while the loser moves down.",
      features: ["Pairs face off by court in each match", "Rankings reflected by assigned court number", "Match winner moves up to a higher court", "Loser moves down to a lower court", "Matches are always played, never a week without competition", "The goal is to reach and stay on Court 1"],
      advantage: "This format guarantees constant competition between pairs, where each match defines your position in the court rankings.",
      systemTitle: "Court-Based Match System",
      systemDesc: "In each match, pairs assigned to the same court face off. The <strong>court number defines your ranking</strong>: Court 1 is the highest position. Matches are always scheduled.",
      winnerUp: "Winner = Moves up",
      loserDown: "Loser = Moves down",
    },
    padelSingles: {
      title: "Padel Ladder Format (Singles)",
      description: "In this dynamic format, individual players compete on hierarchically organized courts. Each match assigns you a different partner, encouraging individual competition while enjoying padel in doubles.",
      features: ["Each match assigns you a random or rotating partner", "Courts organized from lowest to highest level", "The best player on each court MOVES UP to a higher court", "The lowest-performing player MOVES DOWN to a lower court", "The goal is to reach and stay on the main court", "Ideal for meeting different partners while competing"],
      advantage: "This format combines individual competition with the doubles padel experience, allowing you to experience different playing styles while competing to climb the rankings.",
      systemTitle: "Partner Rotation System",
      systemDesc: "In each match you'll play with a <strong>different partner</strong>. This lets you experience diverse playing styles and adapt to different partners while competing individually.",
      bestUp: "Best = Moves up",
      worstDown: "Lowest performance = Moves down",
    },
    elimination: {
      title: "Direct Elimination Format",
      description: "Traditional cup or knockout format. If you lose a match, you're eliminated from the tournament. The last player or team without a loss is the champion.",
      features: ["A single loss eliminates the loser", "Bracket elimination structure", "Rounds: First Round → Round of 16 → Quarterfinals → Semifinals → Final", "High excitement in every match"],
      advantage: "Maximum competitive tension where every match is decisive to continue in the tournament.",
    },
    default: {
      description: "Custom competition format.",
      features: ["Event-specific format", "Check with the organizer for more details"],
    },
  },

  // Organizer Profile
  organizerProfile: {
    loading: "Loading organizer profile...",
    title: "Organizer Profile",
    notFound: "Organizer not found",
    back: "Back",
    tournaments: "Tournaments",
    leagues: "Leagues",
    aboutOrganizer: "About the organizer",
    showMore: "Show more",
    showLess: "Show less",
    website: "Website",
    upcomingEvents: "Upcoming Events",
    noUpcomingTournaments: "No upcoming tournaments",
    noUpcomingLeagues: "No upcoming leagues",
    reviewsAndRatings: "Reviews & Ratings",
    review: "review",
    reviews: "reviews",
    noReviewsYet: "No reviews yet",
    loginToRate: "Log in to rate this organizer",
    yourRating: "Your rating",
    edit: "Edit",
    editRating: "Edit your rating",
    rateOrganizer: "Rate organizer",
    optionalComment: "Optional comment...",
    submitting: "Submitting...",
    submit: "Submit",
    cancel: "Cancel",
    photos: "Photos",
    noPhotos: "The organizer hasn't published photos yet",
    follow: "Follow",
    following: "Following",
    unfollow: "Unfollow",
    followers: "Followers",
    follower: "Follower",
    sponsors: "Official Sponsors",
    shareProfile: "Share Profile",
    profileCopied: "Profile link copied",
    upcoming: "Upcoming",
    past: "Past",
    ranking: "Ranking",
    noRankingData: "No ranking data available",
    sport: "Sport",
    category: "Category",
    subcategory: "Subcategory",
    player: "Player",
    points: "Pts",
    championships: "Championships",
    finalist: "Finalist",
    registerToSeeRanking: "You don't have a ranking in this circuit yet. Sign up for a tournament to get started",
  },

  // Tournament
  tournament: {
    groupPhase: "Group Phase",
    eliminationPhase: "Elimination Phase",
    eliminationDirect: "Direct Elimination",
    sumOfGames: "Sum of Games",
    groups: "Groups",
    elimination: "Elimination",
    final: "Final",
    myGroup: "My Group",
    participants: "Participants",
    backToGroups: "← Back to Groups",
    scheduled: "Scheduled",
    inProgress: "In Progress",
    completed: "Completed",
    unknown: "Unknown",
    champion: "Tournament Champion!",
    congratulations: "Congratulations!",
    you: "You",
    yourTeam: "Your team",
    accessCodeQuestion: "Have an access code?",
    signMeUp: "Sign me up!",
    loading: "Loading...",
    scheduledMatches: "scheduled matches",
    noMatchesFound: "No assigned matches found.",
    matchesComingSoon: "Matches will be scheduled soon.",
    groupNotAssigned: "Group not assigned",
    groupAssignSoon: "The organizer will assign your group soon.",
    myGroupStandings: "My Group - Standings",
    groupStandings: "Group Standings",
    position: "Position",
    pos: "Pos.",
    team: "Team",
    pair: "Pair",
    sets: "Sets",
    games: "Games",
    pts: "Pts",
    diff: "Diff.",
    court: "Court",
    contactOrganizer: "Contact organizer",
    classifiedForElimination: "Qualified for Elimination",
    waitingGroupPhase: "Waiting for all group phase matches to finish",
    waitingGroupPhaseDesc: "Once completed, the qualification ranking for the elimination phase will appear here.",
    firstPlace: "1st Place",
    secondPlace: "2nd Place",
    wildcard: "Wildcard",
    registeredParticipants: "Registered Participants",
    category: "Category",
    subcategory: "Subcategory",
    noParticipants: "No participants registered in this subcategory",
    loadingParticipants: "Loading participants...",
    pairs: "pairs",
    singlePair: "pair",
    matches: "matches",
    match: "match",
    octavos: "Round of 16",
    cuartos: "Quarterfinals",
    semifinales: "Semifinals",
    finished: "Finished",
    finalized: "✓ Finished",
    championLabel: "⭐ CHAMPION ⭐",
    classify: "Qualify",
    classificationTBD: "Classification TBD",
    firstPlaces: "first places",
    bestSeconds: "best 2nds",
    bestThirds: "best 3rds",
    bestFourths: "best 4ths",
    teams: "teams",
    structure: "Structure",
    preparingTournament: "Preparing Your Tournament",
    groupsAssignedSoon: "Groups will be assigned soon. Stay tuned for notifications!",
    notAssignedToGroup: "You haven't been assigned to a group yet",
    allGroups: "All Groups",
    eliminationPhaseTab: "Elimination Phase",
    active: "In Progress",
    upcoming: "Upcoming",
    goToMatch: "Go to match",
    groupPrefix: "Group",
    toBeAssigned: "To be assigned",
    back: "← Back",
    matchSchedulesSoon: "Match schedules will be published soon",
    linkCopied: "Link copied to clipboard",
    joinTournament: "Join the",
    registerToSeeDetails: "Register to See Details",
    registerToSeeDetailsMsg: "Sign up for this tournament to see groups and matches",
    pendingMatch: "Scheduled Match",
    rankingTable: "Standings Table",
    eliminationBracket: "Elimination Bracket",
    eliminationDirectBracket: "Direct Elimination Bracket",
    tournamentMatches: "Tournament Matches",
    groupMatches: "Group Matches",
    classificationByGames: "Classification by Games",
    groupPositions: "Group Standings Table",
    toBeConfirmed: "To be confirmed",
    matchupsConfirmedOnStart: "Matchups will be confirmed when the event starts",
    participant: "Participant",
    viewParticipants: "View participants",
    viewBrackets: "View Brackets",
    positionsUpdatedOnPlay: "Standings will be updated as matches are played",
    toBeDecided: "To be decided",
    participantsToBeDecided: "Participants to be decided",
    bracketGeneratedOnConfirm: "The bracket will be generated automatically once all participants are confirmed",
    datesToBeConfirmed: "Dates to be confirmed",
    matchSchedulesPublished: "Matchups and schedules will be published before the tournament starts",
    roundRobin: "Round Robin",
    matchesPlayed: "MP",
    wins: "W",
    losses: "L",
    goToMatchLabel: "Go to match",
    prizes: "Prizes",
    rules: "Rules",
    tournamentRules: "Tournament Rules",
    categoryLabel: "Category",
    stageLabel: "Stage",
    partnerLabel: "Partner",
    notSpecified: "Not specified",
    statusUpcoming: "Upcoming",
    activeTournament: "Active Tournament",
    accessCode: "Access code",
    gameRulesGroupPhase: "Game Rules - Group Phase",
    gameRulesEliminationPhase: "Game Rules - Elimination Phase",
    gameRulesFlashTournament: "Game Rules - Flash Tournament",
    gameRulesPickleballTournament: "Game Rules - Pickleball Tournament",
    gameRulesSumOfGames: "Game Rules - Sum of Games",
    formatBestOf: "Format: Best of",
    formatSingleSet: "Format: Single set",
    gamesPerSet: "Games per set",
    goldenPoint: "Golden Point",
    superTieBreak: "Super Tie-Break",
    yesApplies: "Yes, applies",
    noApplies: "Does not apply",
    eliminationLoserOut: "Direct elimination: Loser is eliminated",
    classificationByTotalGames: "Classification: By total games won across all rounds",
    timingSection: "Timing",
    warmup: "Warm-up",
    minutes: "minutes",
    restBetweenSets: "Rest between sets",
    minuteParens: "minute(s)",
    sideChange: "Side change",
    conductSection: "Conduct & Tolerance",
    conductOnly: "Conduct",
    arrivalTolerance: "Arrival tolerance",
    doubleElimination: "Double Elimination",
    loadingRules: "Loading rules...",
    noRulesConfigured: "No rules configured for this tournament.",
    yourMatches: "Your Matches",
    noMatchesForTournament: "No scheduled matches found for this tournament.",
    noGroupMatchesForYou: "No group phase matches found for you.",
    opponentTBD: "Opponent TBD",
    groupClassification: "Group Standings",
    noElimMatchesYet: "No elimination phase matches scheduled yet.",
    tbd: "TBD",
    matchesCount: "matches",
  },
  splitPayment: {
    title: "Pending registration payment",
    confirmed: "Registration confirmed!",
    bothPaid: "Both payments were processed successfully. See you at the event!",
    expired: "The payment window has expired. The hold has been released.",
    remaining: "remaining to pay",
    invitedBy: "Invited by",
    yourAmount: "Your part",
    payNow: "Pay now",
    processing: "Processing...",
    paymentConfirmed: "Payment confirmed! Registration is complete.",
    paymentCancelled: "Payment was cancelled. You can try again.",
    notFound: "Payment not found",
    loginRequired: "Sign in to continue",
    loginToPayDesc: "You need to sign in to complete your registration payment.",
    errorCreatingPayment: "Error creating payment session",
  },
};
